import React from 'react';

const LearningMaterialsSection = () => {
  const materials = [
    {
      icon: '📚',
      title: 'Học cùng Marathon',
      description: 'Tài liệu học tập được biên soạn kỹ lưỡng',
      items: [
        { title: 'Sách giáo khoa', icon: '📖' },
        { title: 'Bài giảng', icon: '📝' },
        { title: 'Bài tập', icon: '✏️' },
        { title: 'Đề thi', icon: '📄' }
      ]
    }
  ];

  // Chỉ các lớp từ 7 đến 12, xếp bậc thang (lớp 12 cao nhất)
  const grades = ['Lớp 7', 'Lớp 8', 'Lớp 9', 'Lớp 10', 'Lớp 11', 'Lớp 12'];

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-2">
            Chương Trình Theo <span className="text-green-600">Bộ Giáo Dục</span>
          </h2>
          <p className="text-gray-600">
            Xây dựng lộ trình học tập phù hợp với chương trình của Bộ Giáo Dục
          </p>
        </div>

        {/* Grade Stairs Layout */}
        <div className="flex flex-wrap justify-center items-end gap-4 mb-16">
          {grades.map((grade, index) => (
            <div
              key={index}
              className={`bg-blue-100 hover:bg-blue-200 transition-colors duration-200 text-blue-800 rounded-lg px-6 py-4 text-center shadow-md`}
              style={{ height: `${(index + 1) * 50}px` }} // tăng dần theo lớp
            >
              <span className="font-semibold">{grade}</span>
            </div>
          ))}
        </div>

        {/* Learning Materials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {materials[0].items.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="text-4xl mb-4">{item.icon}</div>
              <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm">{materials[0].description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LearningMaterialsSection;
